import React, { FC } from 'react';
import styled from 'styled-components';
import {
  Notification as NotificationT,
  NotificationGroup,
} from 'api/notifications';
import { BodyShort01 } from 'components/styles';
import { renderInfo } from './info';
import { Primary } from './primary';

const Content = styled.div`
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  ${BodyShort01};
  width: 100%;
`;

const Secondary = styled.div`
  display: flex;
  flex: 1 1 100%;
  margin-left: var(--layout-02);
  margin-top: var(--spacing-02);
  flex-direction: column;
  word-wrap: break-word;
`;

export const Notification: FC<{
  group: NotificationGroup;
  notification: NotificationT;
  open: () => void;
}> = ({ group, notification, open }) => {
  const info = renderInfo(notification);

  return (
    <Content>
      <Primary group={group} notification={notification} open={open} />
      {info != null && <Secondary>{info}</Secondary>}
    </Content>
  );
};
